import { createRouter, createWebHistory } from '@ionic/vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { blurActiveElement } from '@/utils/focus'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/pages/HomePage.vue')
  },
  {
    path: '/booking',
    name: 'Booking',
    component: () => import('@/pages/BookingPage.vue')
  },
  {
    path: '/booking/success',
    name: 'BookingSuccess',
    component: () => import('@/pages/BookingSuccessPage.vue')
  },
  {
    path: '/order/query',
    name: 'OrderQuery',
    component: () => import('@/pages/OrderTokenQueryPage.vue')
  },
  {
    path: '/order/invalid',
    name: 'OrderTokenInvalid',
    component: () => import('@/pages/OrderTokenInvalidPage.vue')
  },
  {
    path: '/order/detail',
    name: 'OrderDetail',
    redirect: '/home'
  },
  {
    path: '/order/:token',
    name: 'OrderTokenDetail',
    component: () => import('@/pages/OrderDetailPage.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/NotFoundPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach(() => {
  blurActiveElement()
})

router.onError((error) => {
  const message = error?.message || ''
  const isChunkLoadError =
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('Loading chunk')

  if (isChunkLoadError && !sessionStorage.getItem('web-app:chunk-reload')) {
    sessionStorage.setItem('web-app:chunk-reload', '1')
    window.location.reload()
  }
})

router.afterEach(() => {
  sessionStorage.removeItem('web-app:chunk-reload')
})

export default router
